import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "clearfix" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_alert = _resolveComponent("b-alert");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_b_alert, {
            dismissible: !_ctx.notDismissable,
            variant: _ctx.msg.variant,
            show: _ctx.msg.hasMessage
        }, {
            default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.msg.message), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["dismissible", "variant", "show"])
    ]));
}
